export const API_GET_ALL_SCANNERS = 'API_GET_ALL_SCANNERS';
export const API_GET_ALL_SCANNERS_SUCCESS = 'API_GET_ALL_SCANNERS_SUCCESS';
export const API_GET_ALL_SCANNERS_FAIL = 'API_GET_ALL_SCANNERS_FAIL';

export const API_ADMIN_GET_ALL_SCANNERS = 'API_ADMIN_GET_ALL_SCANNERS';
export const API_ADMIN_GET_ALL_SCANNERS_SUCCESS = 'API_ADMIN_GET_ALL_SCANNERS_SUCCESS';
export const API_ADMIN_GET_ALL_SCANNERS_FAIL = 'API_ADMIN_GET_ALL_SCANNERS_FAIL';

export const API_ADMIN_GET_SCANNER = 'API_ADMIN_GET_SCANNER';
export const API_ADMIN_GET_SCANNER_SUCCESS = 'API_ADMIN_GET_SCANNER_SUCCESS';
export const API_ADMIN_GET_SCANNER_FAIL = 'API_ADMIN_GET_SCANNER_FAIL';

export const API_ADMIN_PATCH_SCANNER = 'API_ADMIN_PATCH_SCANNER'
export const API_ADMIN_PATCH_SCANNER_SUCCESS = 'API_ADMIN_PATCH_SCANNER_SUCCESS'
export const API_ADMIN_PATCH_SCANNER_FAIL = 'API_ADMIN_PATCH_SCANNER_FAIL'

export const API_ADMIN_POST_SCANNER = 'API_ADMIN_POST_SCANNER'
export const API_ADMIN_POST_SCANNER_SUCCESS = 'API_ADMIN_POST_SCANNER_SUCCESS'
export const API_ADMIN_POST_SCANNER_FAIL = 'API_ADMIN_POST_SCANNER_FAIL'

export const API_ADMIN_DELETE_SCANNER = 'API_ADMIN_DELETE_SCANNER'
export const API_ADMIN_DELETE_SCANNER_SUCCESS = 'API_ADMIN_DELETE_SCANNER_SUCCESS'
export const API_ADMIN_DELETE_SCANNER_FAIL = 'API_ADMIN_DELETE_SCANNER_FAIL'

export const ADMIN_INIT_NEW_SCANNER = 'ADMIN_INIT_NEW_SCANNER'

export const ADMIN_RESET_FOCUS_SCANNER = 'ADMIN_RESET_FOCUS_SCANNER'